<template>
	<div class="bg_content">
		<div class="device_head">
			<span style="color: #b2b2b2">门禁管理 /</span>
			<span style="color: #5c5c5c"> 权限下发</span>
		</div>
		<div class="content_body">
			<el-container style="height: 100%;width:100%;display: flex;">
				<el-aside width="330px" v-show="showAside" style="height: 100%;">
					<el-card :body-style="{ padding: '0px', height: 'calc(100vh - 130px)'}" class="member">
						<div style="text-align: right; padding-top: 20px; padding-left: 20px;height: calc(100% - 80px)">
							<el-row :gutter="24">
								<el-col :span="20">
									<el-input v-model="filterText" placeholder="请搜索部门">
										<i slot="suffix" class="el-input__icon el-icon-search"></i>
									</el-input>
								</el-col>
								<el-col :span="2">
									<img src="@/assets/structure/zoom.png" @click="translation" style="cursor: pointer"
										v-if="showAside" />
								</el-col>
							</el-row>
							<DeptTreeSelect :filterText="filterText" @handleNodeClick="handleDeptmentClick"
								style="margin-top:10px;padding-right: 20px;" />
						</div>
					</el-card>
				</el-aside>
				<el-main :style="{padding: '0px',display: 'grid'}">
					<el-card :body-style="{ padding: '0px 10px'}" class="nexus-el-card">
						<div style="padding-top: 20px;position: relative;display: flex;">
							<div v-if="!showAside">
								<img src="@/assets/structure/zoomr.png" @click="translation" style="cursor: pointer" />
							</div>
							<el-form :inline="true" style="margin-left: 20px;" class="demo-form-inline">
								<el-form-item>
									<el-input v-model="queryParam.likeString" clearable placeholder="姓名、员工工号、设备工号"
										style="width: 260px;"></el-input>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" icon="el-icon-search"
										@click="handleQueryUmsUserPage">搜索</el-button>
								</el-form-item>
							</el-form>
							<div style="position: absolute;right: 10px;">
								<el-button type="primary" icon="el-icon-download" @click="handleDownDeviceUser">权限下发</el-button>
                <el-button type="warning" icon="el-icon-news" @click="handlePermissionPreview">权限预览</el-button>
                <el-button type="danger" icon="el-icon-delete" @click="handleBatchDelete">批量删除规则</el-button>
							</div>
						</div>
						<el-table :data="tableData" :header-cell-style="{background: '#F5F6FA',color: '#5C5C5C',}"
							height="calc(100% - 130px)" @selection-change="handleSelectionChange">
							<template slot="empty">
								<div>
									<img src="@/assets/nodata.png" class="nodata" />
									<div>无数据</div>
								</div>
							</template>
              <el-table-column type="selection"></el-table-column>
							<el-table-column prop="name" label="姓名" width="250">
								<template slot-scope="scope">
									<div class="member_name">
										<img :src="scope.row.headUrl" class="member_head" v-if="scope.row.headUrl" />
										<img src="@/assets/head.png" v-else class="member_head" />
										<div>{{ scope.row.name }}</div>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="员工工号" prop="jobNumber"></el-table-column>
							<el-table-column prop="jobDepartment" label="部门">
								<template slot-scope="scope">
									<div v-if="scope.row.umsDepartment" class="ellipsis">
										{{ scope.row.umsDepartment.name }}
									</div>
								</template>
							</el-table-column>
							<el-table-column label="设备工号" prop="deviceNumber"></el-table-column>
							<el-table-column label="职位" prop="job"></el-table-column>
							<el-table-column label="操作" width="120">
								<template slot-scope="scope">
									<el-link type="warning" style="margin-right: 25px;" @click="handleDelete(scope.row)">删除</el-link>
									<el-link type="primary" @click="handleDetail(scope.row)">查看</el-link>
								</template>
							</el-table-column>
						</el-table>
						<el-pagination v-model:current-page="queryParam.pageNum" :page-size="queryParam.pageSize"
							layout="total, ->, prev, pager, next" :total="total"
							@current-change="handleCurrentChange" />
					</el-card>
				</el-main>
			</el-container>
		</div>
		<company-footer-info />

		<down-device-user-time-rule-dialog ref="downDeviceUserTimeRuleDialogRef" @success="handleQueryUmsUserPage" />
		<user-details ref="userDetailsRef" />
    <permission-preview-drawer ref="permissionPreviewDrawerRef"/>
	</div>
</template>

<script>
	import UserDetails from "@/views/nexus/permissionAllot/userDetails.vue"
	import CompanyFooterInfo from "@/components/companyFooterInfo.vue";
	import DeptTreeSelect from "@/views/nexus/permissionAllot/components/DeptTreeSelect.vue";
	import DownDeviceUserTimeRuleDialog from "@/views/nexus/permissionAllot/DownDeviceUserTimeRuleDialog.vue";
  import PermissionPreviewDrawer from "@/views/nexus/permissionAllot/PermissionPreviewDrawer.vue";
	import { queryUmsUserPage } from "@/api/server/umsUser";
  import {DeviceUserTimeRuleApi} from "@/api/nexus/deviceUserRule";

	export default {
		components: {
			CompanyFooterInfo,
			DeptTreeSelect,
			DownDeviceUserTimeRuleDialog,
			UserDetails,
      PermissionPreviewDrawer
		},
		data() {
			return {
				filterText: '',
				showAside: true,
				queryParam: {
					pageNum: 0,
					pageSize: 20,
					typeList: '2,3,4'
				},
				tableData: [],
				total: 0,
        permissions: []
			}
		},
		methods: {
			handleQueryUmsUserPage() {
				queryUmsUserPage(this.queryParam).then(response => {
					let {
						code,
						data
					} = response;
					if (code == 200) {
						this.total = data.total;
						this.tableData = data.list;
					}
				})
			},
			translation() {
				setTimeout(() => {
					this.showAside = !this.showAside;
				}, 300);
			},
			//选择部门
			handleDeptmentClick(data) {
				this.queryParam.department = data?.id;
				this.handleQueryUmsUserPage();
			},
			handleDetail(row) {
				this.$refs.userDetailsRef.show(row.id)
			},
			handleCurrentChange(page) {
        this.queryParam.pageNum = page;
        this.handleQueryUmsUserPage();
			},
			handleDownDeviceUser() {
				this.$refs.downDeviceUserTimeRuleDialogRef.show();
			},
      handlePermissionPreview(){
        this.$refs.permissionPreviewDrawerRef.show();
      },
      handleSelectionChange(arr) {
        this.permissions = arr;
      },
      async handleDelete(row){
        await this.$confirm("您确定删除该用户门禁规则吗", "提示")
        DeviceUserTimeRuleApi.deleteById({userId:row.id}).then(response => {
          let {code,message} = response;
          if(200 == code){
            this.$message.success("删除成功");
            this.handleQueryUmsUserPage();
          }else {
            this.$message.error(message || '删除失败');
          }
        })
      },
      async handleBatchDelete(){
        if(this.permissions && this.permissions.length>0){
          await this.$confirm("您确定删除选择的用户门禁规则吗", "提示")
          let params = this.permissions.map(permission => {
            return {userId: permission.id};
          });
          DeviceUserTimeRuleApi.batchDelete({list: params}).then(response => {
            let {code,message} = response;
            if(200 == code){
              this.$message.success("删除成功");
              this.handleQueryUmsUserPage();
            }else {
              this.$message.error(message || '删除失败');
            }
          })
        }else{
          this.$message.warning('请选择要删除的权限');
        }
      },
		}
	}
</script>

<style>
	.bg_content {
		width: 100%;
		padding: 16px 20px;
		background: #f4f7fc;
		height: 100%;
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
	}
  .el-link.el-link--warning{
    font-size: 1rem;
  }
	.content_body {
		margin-top: 20px;
		height: 100%;
		width: 100%;
	}

	.member_name {
		display: flex;
		align-items: center;
		font-size: 16px;
		color: #1a1a1a;
	}

	.member_head {
		width: 30px;
		height: 30px;
		object-fit: cover;
		border-radius: 50%;
		margin-right: 10px;
	}

	.table_scope_t {
		color: #4192F3;
	}

	.table_scope_f {
		color: #EE7B32;
	}

	.time_single {
		flex: 0 0 116px;
		/* 不伸缩，基准宽度 116px */
		width: 100px;
		/* 实际宽度 100px */
		height: 30px;
		line-height: 30px;
		text-align: center;
		font-size: 16px;
		color: #1a1a1a;
		background: #dee4ed;
		border-radius: 4px;
		margin-right: 8px;
		white-space: nowrap !important;
		overflow: hidden !important;
		text-overflow: ellipsis !important;
		padding: 5px;

	}

	.card_table {
		height: calc(100% - 80px) !important;
	}

	.search-icon {
		width: 18px;
		height: 18px;
		vertical-align: middle;
	}

	.membel_zoom {
		text-align: right;
		padding: 0px !important;
	}

	.nexus-el-card .el-card__body {
		height: 100%;
	}
</style>